module.exports = __webpack_public_path__ + "img/portfolio__title__img__mobile.2ed2d8b3.png";